<template>
  <ModalDefault :title="textModal" @onCancel="closeModalAndReset" @onClose="closeModalAndReset">
    <div v-if="!isPointPlus" class="container-modal">
      <ButtonPayCard
        :variant="'icon-only'"
        :icon="require('@/features/pdv/assets/img/mp_logo.svg')"
        :alt="'point'"
        text="Mercado Pago Point"
        @handleClick="selectMethod('point')"
      />
      <ButtonPayCard
        :variant="'icon-only'"
        :icon="require('@/features/pdv/assets/img/pos_externo.svg')"
        :alt="'pos-externo'"
        text="POS Externo"
        @handleClick="selectMethod('pos-externo')"
      />
    </div>
    <div v-else-if="isPointPlus" class="payment-status-container">
      El pago se está creando...
      <div class="status-item">
        <SpinnerComp v-if="isLoadingPayment" class="status-spinner" />
        <img v-else-if="canceledPayment" src="@/features/pdv/assets/img/error.svg" alt="error" class="status-icon" />
        <img v-else src="@/features/pdv/assets/img/check.svg" alt="check" class="status-icon" />
        <span v-if="createdPayment">Pago creado</span>
        <span v-else>Creando pago</span>
      </div>
      <div class="status-item">
        <SpinnerComp v-if="isPolling || isLoadingPayment" class="status-spinner" />
        <img v-else-if="paymentStatus == 1" src="@/features/pdv/assets/img/check.svg" alt="check" class="status-icon" />
        <img v-else-if="paymentStatus == 2 || canceledPayment" src="@/features/pdv/assets/img/error.svg" alt="error" class="status-icon" />
        <span v-if="paymentStatus == 1">Procesando el pago</span>
        <span v-else>Esperando pago</span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import SpinnerComp from "@/components/SpinnerComp";
import ModalDefault from "./modals/ModalDefault.vue";
import mixModals from "@/mixins/mixModals.vue";
import ButtonPayCard from "./ButtonPayCard.vue";
import axios from 'axios';
import { parseToQuery } from '@/utils/utils';
import { toast } from 'vue3-toastify';
import { updateOrder } from "@/features/shared/repositories/orders/ordersService.js";

export default {
  name: 'PaymentMethods',
  components: {
    SpinnerComp,
    ModalDefault,
    ButtonPayCard,
  },
  mixins: [mixModals],
  emits: ['paid', 'open-cards-modal'],
  props: {
    order: {
      type: Object,
      required: true,
    },
    shopCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPointPlus: false,
      createdPayment: false,
      isLoadingPayment: false,
      paymentStatus: null, // 0: pending, 1: processed, 2: cancelled
      isPolling: false,
      canceledPayment: false,
      pollingInterval: null,
      modalObserver: null,
    };
  },
  computed: {
    textModal() {
      return this.isPointPlus ? 'Mercado Pago PointPlus' : 'Modo de captura';
    },
  },
  methods: {
    resetModalState() {
      // Reset all state to initial values when modal opens
      this.isPointPlus = false;
      this.createdPayment = false;
      this.isLoadingPayment = false;
      this.paymentStatus = null;
      this.isPolling = false;
      this.canceledPayment = false;
      this.stopPolling();
    },
    async selectMethod(method) {
      if (method === 'point') {
        // Persist captureWay before creating payment (maintain original behavior)
        try {
          const order = this.order;
          order.payments[0].captureWay = 'MP Plus';
          await updateOrder(this.shopCode, order);
        } catch (e) {
          toast.error('No se pudo preparar el cobro. Intente nuevamente.');
          return;
        }
        this.isPointPlus = true;
        this.isLoadingPayment = true;
        this.createdPayment = false;

        const params = {
          shopCode: this.shopCode,
          externalReference: this.order.uuid,
          total: String(this.order.amount),
        };
        axios
          .post(`/api/pdv/createPaymentPointPlus`, params)
          .then((res) => {
            this.isLoadingPayment = false;
            if (res.data.responseCode === 0) {
              this.createdPayment = true;
              this.initPolling(params);
            } else {
              this.closeModalAndReset();
              toast.error(res.data.responseMessage);
            }
          })
          .catch(() => {
            toast.error('No se pudo realizar el cobro. Vuelva a intentarlo o elija otro medio de pago.');
            this.closeModalAndReset();
          });
      } else {
        this.closeModalById('#modalDefault');
        this.$emit('open-cards-modal');
      }
    },

    initPolling(params) {
      this.isPolling = true;
      this.paymentStatus = 0; // pending

      this.pollingInterval = setInterval(() => {
        // Stop polling if component is no longer in PointPlus mode
        if (!this.isPointPlus) {
          this.stopPolling();
          return;
        }

        axios
          .get(`/api/pdv/getPaymentPointPlus/?${parseToQuery({ Id: params.externalReference })}`)
          .then((res) => {
            if (res.data.responseCode === 0) {
              const status = res.data.status;
              this.paymentStatus = status;
              if (status == 1) {
                // Pago procesado exitosamente
                this.stopPolling();
                this.$emit('paid', { authCode: res.data.authCode });
                this.closeModal();
              } else if (status == 2) {
                // Pago cancelado
                this.stopPolling();
                toast.error('La orden de pago ha sido cancelada.');
                this.closeModalAndReset();
              }
            } else {
              toast.error('No se pudo realizar el cobro. Vuelva a intentarlo o elija otro medio de pago.');
              this.stopPolling();
              this.closeModalAndReset();
            }
          })
          .catch(() => {
            // Error en la petición
            this.stopPolling();
            this.closeModalAndReset();
          });
      }, 5000);
    },

    stopPolling() {
      this.isPolling = false;
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    closeModal() {
      this.resetPaymentState();
      this.closeModalById('#modalDefault');
    },
    closeModalAndReset() {
      // const order = this.$pdv.getOrder
      // order.payments = []
      // updateOrder(this.shopCode, order)
      this.resetPaymentState();
      this.closeModalById('#modalDefault');
    },
    resetPaymentState() {
      this.stopPolling();
      this.isPointPlus = false;
      this.createdPayment = false;
      this.isLoadingPayment = false;
      this.paymentStatus = null;
      this.canceledPayment = false;
    },
    cleanup() {
      this.closeModalAndReset();
      // Remove event listeners
      window.removeEventListener('beforeunload', this.handlePageUnload);
      window.removeEventListener('popstate', this.handlePageUnload);
      // Clean up modal observer
      if (this.modalObserver) {
        this.modalObserver.disconnect();
        this.modalObserver = null;
      }
    },
    handlePageUnload() {
      this.stopPolling();
    },
    observeModalOpening() {
      const modal = document.getElementById("modalDefault");
      this.modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.attributeName === "class" &&
            modal.classList.contains("open")
          ) {
            this.resetModalState();
          }
        });
      });

      this.modalObserver.observe(modal, { attributes: true });
    },
  },
  mounted() {
    // Reset state when component mounts
    this.resetModalState();
    // Add event listener for browser navigation (back/forward buttons)
    window.addEventListener('beforeunload', this.handlePageUnload);
    window.addEventListener('popstate', this.handlePageUnload);
    
    // Watch for modal opening by observing DOM changes
    this.observeModalOpening();
  },
  beforeUnmount() {
    this.cleanup();
  },
  beforeRouteLeave() {
    // Vue Router navigation guard
    this.cleanup();
  },
};
</script>

<style lang="scss" >
.container-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    margin: 4rem 0;

    .button-pay-cards {
      flex-direction: column;
      color: black;
      width: 16rem;
      height: 12rem;
      justify-content: space-between;
    
      .button-icon-pay {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        
        img {
          width: 100% !important;
          height: auto;
          object-fit: contain;
        }
      }
      &:not(:has(.button-icon-pay)) {
        justify-content: flex-end;
        align-items: center;
      }
    }
}
  
.spinner-circle{
  width: 25px;
  height: 25px;
}
  
.payment-status-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 3rem 5rem;  font-size: 18px;
  font-weight: bold;
  color: #333;
  
  .status-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    
    .status-icon {
      width: 24px;
      height: 24px;
      color: $greenColor;
    }
    
    .status-spinner {
      width: 24px;
      height: 24px;
    }
    
    span {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
}

</style>
